module.exports = __webpack_public_path__ + "book-icon-on.png?71f59c2ede9cf4d52b2eb9d98dc56fbe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/book-icon-on.png
// module id = 48
// module chunks = 0